import React from 'react';
import { classNames } from '../../utils/classNames';

interface TextAreaProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
  helpText?: string;
  error?: boolean;
  maxLength?: number;
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 3,
  required = false,
  disabled = false,
  className = '',
  icon,
  helpText,
  error = false,
  maxLength = 1500
}) => {
  const textareaClasses = classNames(
    'w-full px-4 py-3 bg-white border border-red-500/30 rounded-lg shadow-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed resize-vertical',
    error && 'border-red-500 focus:ring-red-500',
    className
  );

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  return (
    <div className="mb-4">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {icon && <span className="inline-block mr-1">{icon}</span>}
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        className={textareaClasses}
      />
      <div className="flex justify-between items-center mt-1">
        {helpText && (
          <p className="text-gray-500 text-xs">{helpText}</p>
        )}
        <p className={classNames(
          'text-xs',
          value.length > maxLength * 0.9 ? 'text-red-500' : 'text-gray-500'
        )}>
          {value.length}/{maxLength}
        </p>
      </div>
    </div>
  );
};